import { useState, useEffect } from "react";
import { useForm } from 'react-hook-form';
import HeaderBar from "../HeaderBar";
import useStateMachineWrapper, { sendState } from "../../helpers/useStateMachineWrapper";
import sleep from "../../helpers/sleep";
import { withHookFormMask } from "use-mask-input";
import MobileNextButton from "../MobileNextButton";

const OrderCustomer = (props) => {
  const { actions, state } = useStateMachineWrapper();
  const [isLoading, setIsLoading] = useState(false);

  const { control, register, handleSubmit, getValues, watch, formState: { errors, isValid, submitCount } } = useForm({
    mode: 'onTouched',
    defaultValues: {
      firstName: state.session.firstName,
      lastName: state.session.lastName,
      phoneNumber: state.session.phoneNumber,
      altPhone: state.session.altPhone,
      email: state.session.email,
      preferredContactMethod: state.session.preferredContactMethod,
      ReceiveSMS: state.session.ReceiveSMS === 'Y' || state.session.ReceiveSMS === undefined,
      ReceivePromotionalSMS: state.session.ReceivePromotionalSMS === 'Y' || state.session.ReceivePromotionalSMS === undefined,
    },
  });

  // Sync state as checkboxes are changed
  useEffect(() => {
    const subscription = watch((value, { name }) => {
      if (name === "ReceivePromotionalSMS" || name === "ReceiveSMS") {
        actions.update({
          [name]: value ? 'Y' : 'N',
        });
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  useEffect(() => {
    if (state.session.ReceiveSMS === undefined || state.session.ReceivePromotionalSMS === undefined) {
      actions.update({
        ReceiveSMS: 'Y',
        ReceivePromotionalSMS: 'Y',
      });
    }
  }, []);

  const updateData = (data) => {
    actions.update({
      ...data,
      ReceiveSMS: data.ReceiveSMS ? 'Y' : 'N',
      ReceivePromotionalSMS: data.ReceivePromotionalSMS ? 'Y' : 'N',
    });
  };

  const manuallySubmit = async () => {
    setIsLoading(true);
    handleSubmit(updateData)();

    await sleep(50);

    let _state = state;
    let { page, ..._session } = _state.session;
    _state.session = _session;

    const values = getValues();
    _state.session = {
      ..._state.session,
      ...values,
      ReceiveSMS: values.ReceiveSMS ? 'Y' : 'N',
      ReceivePromotionalSMS: values.ReceivePromotionalSMS ? 'Y' : 'N',
    };

    if (state.session.isPreorder) {
      _state.session.submitting = true;
      _state.session.payment = 'noautopay';
    }

    await sendState(_state);
    setIsLoading(false);
    return true;
  };

  return (
    <>
      <HeaderBar
        backPage={'order-summary'}
        nextPage={state.session.isPreorder ? 'order-complete' : 'order-payment'}
        nextPageLoading={isLoading}
        nextPageEnabled={isValid}
        nextPageAction={manuallySubmit}
      >
        <h1 className="bigger">Almost There!</h1>
        {state.session.isPreorder === true
          ? <p>Let's get your information so we can contact you when services are available.</p>
          : <p>Let's get your information so we can review and confirm your selections.</p>}
      </HeaderBar>

      <div className="mt-4">
        <form onSubmit={handleSubmit(updateData)} className="grid grid-flow-row-dense grid-cols-1 md:grid-cols-2 gap-4">
          <input type="text" placeholder="First name" {...register("firstName", { required: 'First name is required' })} />
          <input type="text" placeholder="Last name" {...register("lastName", { required: 'Last name is required' })} />

          <input type="text" placeholder="Cell Phone Number" {...withHookFormMask(register("phoneNumber", { required: 'Cell phone number is required' }), ['(999) 999-9999'])} />
          <input type="text" placeholder="Alt Phone Number" {...withHookFormMask(register("altPhone"), ['(999) 999-9999'])} />

          <input type="text" placeholder="Email Address" {...register("email", { required: 'Email address is required', pattern: { value: /^\S+@\S+$/i, message: 'Please enter a valid email address' } })} />

          <select {...register("preferredContactMethod")} placeholder="How should we contact you?">
            <option value="">How should we contact you?</option>
            <option value="email">Email</option>
            <option value="phone">Phone</option>
          </select>

          <div className="col-span-full sms-concent-wrap">
            <label className="!text-sm sms-concent">
              <input type="checkbox" value="Y" {...register("ReceiveSMS", { required: 'Agreement to receive SMS from i3 Broadband is required' })} />
              By providing your cell phone number you agree to receive texts from i3 Broadband, LLC about fiber-based service availability, support and/or billing-related information. It will not be used to market new services to you without your consent.
            </label>

            <label className="!text-sm sms-concent">
              <input type="checkbox" value="Y" {...register("ReceivePromotionalSMS")} />
              Please text me about new services and products available.
            </label>
          </div>

          {Object.keys(errors).length > 0 && (
            <div className="col-span-full">
              <div className="bg-red-50 border-[1px] border-red-100 rounded mt-4 p-4 text-left shadow">
                <ul>{Object.values(errors).map((v, i) => <li key={i}>{v.message}</li>)}</ul>
              </div>
            </div>
          )}
        </form>
      </div>

      <HeaderBar backPage={'order-summary'} nextPage={state.session.isPreorder ? 'order-complete' : 'order-payment'} nextPageLoading={isLoading} nextPageEnabled={isValid} nextPageAction={manuallySubmit}></HeaderBar>
    </>
  );
};

export default OrderCustomer;
